/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getData, getOne } = Response;

class User {
    constructor(clientId) {
        this.requests = new Requests();
        this.clientId = clientId;
    }

    cancel = () => {
        this.requests.cancel();
    };

    get = async (p = {}) => {
        const params = p;
        const { size } = params;

        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/user', {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                debug.e('No User Found', params, response);
                return false;
            }

            if (size === -1) {
                return getData(response);
            }

            return getOne(response);
        } catch (e) {
            debug.e('Unable to load User', e);
            return false;
        }
    };

    getAll = async (params) => this.get({ ...params, size: -1 });

    getCount = async (p = {}) => {
        const params = { active: true, size: -1, ...p };

        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/user', {
                cancelToken: this.requests.token(),
                params
            });
            return Response.getDataCount(response);
        } catch (e) {
            debug.e(e);
            return 0;
        }
    };
}

export default User;
